export enum TileType {
  TEMPERATURE = "Temperature",
  WIND = "Wind",
  CLOUDS = "Clouds",
  PRECIPITATION = "Precipitation",
  PRESSURE = "Pressure",
}

export enum TileAction {
  TEMP_NEW = "temp_new",
  WIND_NEW = "wind_new",
  CLOUDS_NEW = "clouds_new",
  PRECIPITATION_NEW = "precipitation_new",
  PRESSURE_NEW = "pressure_new",
}

export const TILE_ACTION_TO_TYPE: Record<TileAction, TileType> = {
  [TileAction.TEMP_NEW]: TileType.TEMPERATURE,
  [TileAction.WIND_NEW]: TileType.WIND,
  [TileAction.CLOUDS_NEW]: TileType.CLOUDS,
  [TileAction.PRECIPITATION_NEW]: TileType.PRECIPITATION,
  [TileAction.PRESSURE_NEW]: TileType.PRESSURE,
};

